import { getUserInfo } from '@/utils/auth'

const state = {
	regionId: 1,
	role: ''
}

const mutations = {
	SET_REGION_ID: (state, regionId) => {
		state.regionId = regionId
	},
	SET_ROLE: (state, role) => {
		state.role = role
	}
}

const actions = {
	getRegionId({ commit }) {
		return new Promise(resolve => {
			const userInfo = getUserInfo()
			let region = userInfo.region
			commit('SET_REGION_ID', region)
			resolve(region)
		})
	},
	changeRole({ commit }) {
		return new Promise(resolve => {
			commit('SET_ROLE', 'user')
			resolve('user')
		})
	},
	logout({ commit }) {
		return new Promise(resolve => {
			commit('SET_REGION_ID', '')
			resolve()
		})
	}
}

export default {
	namespace: true,
	state,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js